import React from 'react'
import warning_icon from '../../assets/warning.svg'
import './index.css'

function Warning({ tabSwitchCount, onClose }) {
    return (
        <div className="warning-wrapper">
            <img className="warning-icon" alt="warning" src={warning_icon} />
            <p className="warning-header">warning!</p>
            <p className="warning-content">{`You have changed your tab/browser ${tabSwitchCount} times while taking the test.`}</p>
            <p className="warning-buton" onClick={onClose}>
                Close
            </p>
        </div>
    )
}

export default Warning
